const lang = {
    'first-stop': 'First Stop',
    'taoyuan-taiwan': 'Taoyuan, Taiwan',
    'announcement': 'GoShare is happy to announce it is operating in Taoyuan, Taiwan.',
    'description': '* For details on the operation area, please check the GoShare App.',
};

export default lang;
